export const branchNames = [
    {
        value: '632005',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'AFRICAN BANK',
        value: '430000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'ALBARAKA BANK',
        value: '800000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'BZ MUTUAL BANK',
        value: '888000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'BIDVEST BANK LIMITED',
        value: '462005',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'BNP PARIBAS SA',
        value: '688000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'CAPITEC BANK LIMITED',
        value: '470010',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'CITIBANK',
        value: '350005',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'DISCOVERY BANK LTD',
        value: '679000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'FINBOND MUTUAL BANK',
        value: '589000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'FINBOND NET1',
        value: '591000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'FIRST NATIONAL BANK',
        value: '250655',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'FIRSTRAND BANK',
        value: '201419',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'GRINDROD',
        value: '584000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'HSBC BANK',
        value: '587000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'INVESTEC',
        value: '580105',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'JP MORGAN',
        value: '432000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'MRCB',
        value: '450105',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'NEDBANK',
        value: '198765',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'NEDBANK BOND',
        value: '170305',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'OLYMPUS MOBILE',
        value: '585001',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'PBL',
        value: '720026',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'PEP',
        value: '400001',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'PERMANENT BANK',
        value: '760005',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'RMB',
        value: '261251',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'SAPO',
        value: '460005',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'SASFIN BANK',
        value: '683000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'STANDARD BANK',
        value: '051001',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'STATE BANK OF INDIA',
        value: '801000',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'TYME BANK LIMITED',
        value: '678910',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'UBANK',
        value: '431010',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'UBANK LTD',
        value: '431010',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'UNIBA',
        value: '790005',
        label: 'Universal Branch Code',
    },
    {
        bankName: 'VBS MUTUAL BANK',
        value: '588000',
        label: 'Universal Branch Code',
    },
];
